export const ARTISTS_ADD = 'ARTISTS_ADD'
export const ARTISTS_FETCH = 'ARTISTS_FETCH'
export const ARTISTS_IS_LOADING = 'ARTISTS_IS_LOADING'
export const ARTISTS_ERROR = 'ARTISTS_ERROR'
export const ARTISTS_SUCCESS = 'ARTISTS_SUCCESS'

export const EVENIMENTS_ADD = 'EVENIMENTS_ADD'
export const EVENIMENTS_FETCH = 'EVENIMENTS_FETCH'
export const EVENIMENTS_IS_LOADING = 'EVENIMENTS_IS_LOADING'
export const EVENIMENTS_ERROR = 'EVENIMENTS_ERROR'
export const EVENIMENTS_SUCCESS = 'EVENIMENTS_SUCCESS'

export const PLACES_IS_LOADING = 'PLACES_IS_LOADING'



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js